<mat-selection-list #matSelection  role="list" class="list-plantillas" (selectionChange)="getSelected($event)">
  <mat-list-option *ngFor="let plantillaItem of plantillasList" [value]="plantillaItem">
    {{ plantillaItem.IdPlantilla + ' - ' + plantillaItem.Nplantilla }}
  </mat-list-option>
</mat-selection-list>
